import { getNumber, isRecord, getT, getGenericValue, getString, getBoolean, getDate } from './../../common/utils/recordtype-utils';
import { GenericValue } from 'hisng';
import { MaritalStatusValue, EducationalAttainmentValue, ErpCountryValue } from '../../common/person/model/person-values';
import { PartTimeTypeValue } from '../../employment/model/employment-values';

export class JobApplication {
    id?: number | null;
    gender?: GenericValue;
    title?: GenericValue;
    firstname?: string;
    surname?: string;
    additionalName?: string;
    birthDate?: Date;
    maritalStatus?: MaritalStatusValue;
    nationality?: ErpCountryValue;
    unemployed?: boolean;
    disability?: boolean;
    disabilityInPercent?: number;
    educationalAttainment?: EducationalAttainmentValue;
    informationSource?: GenericValue;
    finalGrade?: number;
    academicDegree?: GenericValue;
    street?: string;
    postcode?: string;
    city?: string;
    addressSupplement?: string;
    country?: ErpCountryValue;
    phoneNumber?: string;
    mobileNumber?: string;
    emailaddress?: string;
    parttime?: boolean;
    partTimeType?: PartTimeTypeValue;
    partTimeScope?: number;
    earliestCommencementDate?: Date;
    salaryRequirements?: number;
    officialDesignation?: GenericValue;
    jobAdvertisementId?: number;

    constructor( json?: unknown ) {
        if ( isRecord( json ) ) {
            this.id = getNumber( json, 'id' );
            this.gender = getGenericValue( json, 'gender' );
            this.title = getGenericValue( json, 'title' );
            this.firstname = getString( json, 'firstname' );
            this.surname = getString( json, 'surname' );
            this.additionalName = getString( json, 'additionalName' );
            this.birthDate = getDate( json, 'birthDate' );
            this.maritalStatus = getGenericValue( json, 'maritalStatus' );
            this.nationality = getGenericValue( json, 'nationality' );
            this.unemployed = getBoolean( json, 'unemployed' );
            this.disability = getBoolean( json, 'disability' );
            this.disabilityInPercent = getNumber( json, 'disabilityInPercent' );
            this.educationalAttainment = getGenericValue( json, 'educationalAttainment' );
            this.informationSource = getGenericValue( json, 'informationSource' );
            this.finalGrade = getNumber( json, 'finalGrade' );
            this.academicDegree = getGenericValue( json, 'academicDegree' );
            this.street = getString( json, 'street' );
            this.postcode = getString( json, 'postcode' );
            this.city = getString( json, 'city' );
            this.addressSupplement = getString( json, 'addressSupplement' );
            this.country = getGenericValue( json, 'country' );
            this.phoneNumber = getString( json, 'phoneNumber' );
            this.mobileNumber = getString( json, 'mobileNumber' );
            this.emailaddress = getString( json, 'emailaddress' );
            this.parttime = getBoolean( json, 'parttime' );
            this.partTimeType = getGenericValue( json, 'partTimeType' );
            this.partTimeScope = getNumber( json, 'partTimeScope');
            this.earliestCommencementDate = getDate( json, 'earliestCommencementDate' );
            this.salaryRequirements = getNumber( json, 'salaryRequirements' );
            this.officialDesignation = getGenericValue( json, 'officialDesignation' );
            this.jobAdvertisementId = getNumber( json, 'jobAdvertisementId' );
        }
    }
}
